export const validatePassword = (password) => {
	const passwordRegex =
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+={}\[\]|\\:;"'<>,.?/~`-]{8,}$/;
	if (passwordRegex.test(password)) {
			return true;
	} else {
			return false;
	}
};